import {createLinkForDownload} from 'utils';

export const downloadExport = (mimeType: string, data: string, fileName: string) => {
  createLinkForDownload(`data:${mimeType};base64,${data}`, fileName);
};
